import React from 'react'
import AntdCheckbox from 'antd/lib/checkbox'

import './checkbox.less'

import { mergeClassName } from '../utils'

const Checkbox = (props) => {
  const { checked, className, dark, ...otherProps } = props
  return (
    <React.Fragment>
      <AntdCheckbox
        {...otherProps}
        className={mergeClassName([className, dark ? 'dark-theme' : ''])}
        checked={checked}
      />
    </React.Fragment>
  )
}
Checkbox.Group = AntdCheckbox.Group

Checkbox.displayName = 'DmpCheckbox'

export default Checkbox
